import { render, staticRenderFns } from "./dadosRM.vue?vue&type=template&id=15c75144&"
import script from "./dadosRM.vue?vue&type=script&lang=js&"
export * from "./dadosRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports